import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFarm } from '../context/FarmContext';
import { getFarmOverviewPath } from '../utils/farmRoutes';

/**
 * /dashboard → /farms/:farmId/overview. Waits for auth; uses FarmContext + JWT farm id.
 * Kept in a small module to avoid coupling App.js to farm routing details.
 */
export default function FarmDashboardRedirect() {
  const { ready, user } = useAuth();
  const { effectiveFarmId } = useFarm();

  if (!ready) {
    return null;
  }

  const farmId = effectiveFarmId || user?.farmId;
  const target = getFarmOverviewPath(farmId);
  if (!target) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={target} replace />;
}
